'use client'
import React from 'react'

import { UnderlineIcon } from '../../icons/Underline/index.js'
import { LeafButton } from '../Button.js'

export const UnderlineLeafButton = () => (
  <LeafButton format="underline">
    <UnderlineIcon />
  </LeafButton>
)
